import { cn } from "@/lib/utils";


export function ForReferenceOnly({
  className = '',
}: { className?: string }) {
  return (
    <span className={
      cn(
        "text-2xs text-annotation-foreground",
        className,
      )
    }>
      内容由 AI 生成，仅供参考
    </span>
  )
}